import { AxiosError, AxiosResponse } from "axios";
import { DataType, FieldType } from "@websential/cosmic-v20";
import { IGetListRequest, IResponse, IServerError } from "../../models/common";
import { IRoles, IRolesListPayload, IRolesResponse } from "../../models";

import { GridSize } from "@mui/material";
import { IDropDownListResponse } from "../../models/common/IDropDownListResponse";
import http from "../../common/http-commons";

// import { IFixedAndMetaField } from 'common/FlexFieldsUtils';

// import { IVendorListPayload, IVendorRequest, IVendorResponse } from 'models/vendor';
// import { CLIENT_SETUP_FORM, CLIENT_SETUP_FORM_FOR_ADMIN_USER } from 'screensLayoutData/client';

// import { IAPIKeysRequest, IAPIKeysResponse } from '../models';

// import { IRolesListPayload, IRolesRequest, IRolesResponse } from '../models/roles';

// import { INITIAL_PAGE_SIZE } from 'common/constants';

export const RolesService = {
  getRoles: async (
    data: IGetListRequest,
    navigateToLogout: (path: string) => void,
  ): Promise<
    IRolesListPayload | IServerError | IResponse | IRolesResponse[]
  > => {
    try {
      const response: AxiosResponse<IRolesListPayload> =
        await http.get<IRolesListPayload>(
          "/v1/roles/?order_by=" +
            data.order_by +
            "&order_direction=" +
            data.order_direction +
            "&page=" +
            data.page +
            "&size=" +
            data.size +
            "&search_query=" +
            data.search_query,
        );

      if (response.status === 200) {
        return response.data;
      } else if (response.status === 400) {
        return {
          status: false,
          message: "Bad Request.",
          error: true,
        };
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }
      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      const errorMessage =
        axiosError.response && typeof axiosError.response.data === "string"
          ? axiosError.response.data
          : "Unknown error";
      if (axiosError && axiosError.status === 401) {
        navigateToLogout("/logout");
        return {
          status: false,
          message: "UnAuthrized",
        };
      } else {
        return {
          status: false,
          message: errorMessage,
        };
      }
    }
  },
  getRolesRightsAndPermissionsDefaultScreenLoadData: async (
    // isOwner: boolean | number,
    accountType: number,
    navigateToLogout: (path: string) => void,
  ): Promise<
    IRolesListPayload | IServerError | IResponse | IRolesResponse[]
  > => {
    try {
      const response: AxiosResponse<IRolesListPayload> =
        await http.get<IRolesListPayload>(
          `/v1/assign-screens-permissions/default-screens-data/and-there-permissions/?account_type=${accountType}`,
        );

      if (response.status === 200) {
        return response.data;
      } else if (response.status === 400) {
        return {
          status: false,
          message: "Bad Request.",
          error: true,
        };
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }
      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      const errorMessage =
        axiosError.response && typeof axiosError.response.data === "string"
          ? axiosError.response.data
          : "Unknown error";
      if (axiosError && axiosError.status === 401) {
        navigateToLogout("/logout");
        return {
          status: false,
          message: "UnAuthrized",
        };
      } else {
        return {
          status: false,
          message: errorMessage,
        };
      }
    }
    // let fixedResponse: any = {
    //   roles: [
    //     {
    //       screenId: "123123",
    //       screen: "Client List",
    //       add: { name: "add", type: "switch" },
    //       view: { name: "view", type: "switch" },
    //       update: { name: "update", type: "switch" },
    //       delete: { name: "delete", type: "switch" },
    //       print: { name: "Print", type: "switch" },
    //       status: {
    //         name: "status",
    //         type: "list",
    //         values: ["active", "inactive"],
    //       },
    //     },
    //     {
    //       screenId: "123123dfv",
    //       screen: "Client Setup  ",
    //       view: { name: "view", type: "switch" },
    //       add: { name: "add", type: "switch" },
    //       update: { name: "update", type: "switch" },
    //       delete: { name: "delete", type: "switch" },
    //       calculate: { name: "calculate", type: "switch" },
    //       pay_period: {
    //         name: "pay_period",
    //         type: "list",
    //         values: [
    //           "monthly",
    //           "semi monthly",
    //           "Regular",
    //           "bi weekly",
    //           "annually",
    //         ],
    //       },
    //     },
    //   ],
    //   headerColumns: [
    //     {
    //       field: "screen",
    //       headerName: "Screens",
    //       description: "",
    //       flex: 1,
    //       hide: false,
    //       hideable: false,
    //       sortable: true,
    //       sortingOrder: "asc",
    //       resizable: false,
    //       type: "string",
    //       align: "left",
    //       headerAlign: "center",
    //       hideSortIcons: false,
    //       disableColumnMenu: true,
    //       disableReorder: true,
    //       disableExport: true,
    //       maskable: false,
    //       isFixed: true,
    //       sequence: 0,
    //       frozenColumn: false,
    //       footer: true,
    //     },
    //     {
    //       field: `view.type`,
    //       headerName: `View`,
    //       description: "",
    //       flex: 1,
    //       hide: false,
    //       hideable: false,
    //       sortable: true,
    //       sortingOrder: "asc",
    //       resizable: false,
    //       type: "string",
    //       align: "center",
    //       headerAlign: "center",
    //       hideSortIcons: false,
    //       disableColumnMenu: true,
    //       disableReorder: true,
    //       disableExport: true,
    //       maskable: false,
    //       isFixed: true,
    //       sequence: 0,
    //       frozenColumn: false,
    //       footer: null,
    //     },
    //     {
    //       field: "add.type",
    //       headerName: "Add",
    //       description: "",
    //       flex: 1,
    //       hide: false,
    //       hideable: false,
    //       sortable: true,
    //       sortingOrder: "asc",
    //       resizable: false,
    //       type: "string",
    //       align: "center",
    //       headerAlign: "center",
    //       hideSortIcons: false,
    //       disableColumnMenu: true,
    //       disableReorder: true,
    //       disableExport: true,
    //       maskable: false,
    //       isFixed: true,
    //       sequence: 1,
    //       frozenColumn: false,
    //       footer: null,
    //     },
    //     {
    //       field: "update.type",
    //       headerName: "Update",
    //       description: "",
    //       flex: 1,
    //       hide: false,
    //       hideable: false,
    //       sortable: true,
    //       sortingOrder: "asc",
    //       resizable: false,
    //       type: "string",
    //       align: "center",
    //       headerAlign: "center",
    //       hideSortIcons: false,
    //       disableColumnMenu: true,
    //       disableReorder: true,
    //       disableExport: true,
    //       maskable: false,
    //       isFixed: true,
    //       sequence: 3,
    //       frozenColumn: false,
    //       footer: null,
    //     },
    //     {
    //       field: "delete.type",
    //       headerName: "Delete",
    //       description: "",
    //       flex: 1,
    //       hide: false,
    //       hideable: false,
    //       sortable: true,
    //       sortingOrder: "asc",
    //       resizable: false,
    //       type: "string",
    //       align: "center",
    //       headerAlign: "center",
    //       hideSortIcons: false,
    //       disableColumnMenu: true,
    //       disableReorder: true,
    //       disableExport: true,
    //       maskable: false,
    //       isFixed: true,
    //       sequence: 3,
    //       frozenColumn: false,
    //       footer: null,
    //     },
    //     {
    //       field: "print.type",
    //       headerName: "Print",
    //       description: "",
    //       flex: 1,
    //       hide: false,
    //       hideable: false,
    //       sortable: true,
    //       sortingOrder: "asc",
    //       resizable: false,
    //       type: "string",
    //       align: "center",
    //       headerAlign: "center",
    //       hideSortIcons: false,
    //       disableColumnMenu: true,
    //       disableReorder: true,
    //       disableExport: true,
    //       maskable: false,
    //       isFixed: true,
    //       sequence: 0,
    //       frozenColumn: false,
    //       footer: null,
    //     },
    //     {
    //       field: `status.type`,
    //       headerName: `Status`,
    //       description: "",
    //       flex: 1,
    //       hide: false,
    //       hideable: false,
    //       sortable: true,
    //       sortingOrder: "asc",
    //       resizable: false,
    //       type: "string",
    //       align: "left",
    //       headerAlign: "center",
    //       hideSortIcons: false,
    //       disableColumnMenu: true,
    //       disableReorder: true,
    //       disableExport: true,
    //       maskable: false,
    //       isFixed: true,
    //       sequence: 0,
    //       frozenColumn: false,
    //       footer: null,
    //       maxWidth: 300,
    //       minWidth: 300,
    //     },
    //     {
    //       field: "calculate.type",
    //       headerName: "Calculate",
    //       description: "",
    //       flex: 1,
    //       hide: false,
    //       hideable: false,
    //       sortable: true,
    //       sortingOrder: "asc",
    //       resizable: false,
    //       type: "string",
    //       align: "center",
    //       headerAlign: "center",
    //       hideSortIcons: false,
    //       disableColumnMenu: true,
    //       disableReorder: true,
    //       disableExport: true,
    //       maskable: false,
    //       isFixed: true,
    //       sequence: 1,
    //       frozenColumn: false,
    //       footer: null,
    //     },
    //     {
    //       field: "pay_period.type",
    //       headerName: "Pay Period",
    //       description: "",
    //       flex: 1,
    //       hide: false,
    //       hideable: false,
    //       sortable: true,
    //       sortingOrder: "asc",
    //       resizable: false,
    //       type: "string",
    //       align: "left",
    //       headerAlign: "center",
    //       hideSortIcons: false,
    //       disableColumnMenu: true,
    //       disableReorder: true,
    //       disableExport: true,
    //       maskable: false,
    //       isFixed: true,
    //       sequence: 1,
    //       frozenColumn: false,
    //       footer: null,
    //       maxWidth: 300,
    //       minWidth: 300,
    //     },
    //   ],
    // };
    // return new Promise((resolve) =>
    //   setTimeout(() => resolve(fixedResponse), 1000)
    // );
  },
  getById: async (
    id: string | undefined,
    navigateToLogout: (path: string) => void,
  ): Promise<IRoles | IServerError | IResponse | null | any> => {
    if (!id) return null;
    try {
      const response: AxiosResponse<IRoles> = await http.get<IRoles>(
        `/v1/roles/${id}/`,
      );

      if (response.status === 200) {
        return response.data;
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }

      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      const errorMessage =
        axiosError.response && typeof axiosError.response.data === "string"
          ? axiosError.response.data
          : "Unknown error";
      if (axiosError && axiosError.status === 401) {
        navigateToLogout("/logout");
        return {
          status: false,
          message: "UnAuthrized",
        };
      } else {
        return {
          status: false,
          message: errorMessage,
        };
      }
    }
  },
  create: async (
    requestPayload: any,
  ): Promise<IRoles | IServerError | IResponse | any> => {
    if (requestPayload.id) {
      try {
        const response: AxiosResponse<IRoles> = await http.put<IRoles>(
          `/v1/roles/${requestPayload.id}/`,
          requestPayload,
        );

        if (response.status === 200) {
          return response;
        } else if (response.status === 400) {
          return response.data;
        } else if (response.status === 500) {
          return {
            status: false,
            message: "Something went wrong.",
            error: true,
          };
        }
      } catch (error) {
        const axiosError = error as AxiosError;
        console.error("An error occurred:", axiosError);
        const errorMessage =
          axiosError.response && typeof axiosError.response.data === "string"
            ? axiosError.response.data
            : "Unknown error";
        if (axiosError && axiosError.status === 401) {
          requestPayload.navigateToLogout("/logout");
          return {
            status: false,
            message: "UnAuthrized",
          };
        } else {
          return {
            status: false,
            message: errorMessage,
          };
        }
      }
    }

    try {
      const response: AxiosResponse<IRoles> = await http.post<IRoles>(
        `/v1/roles/`,
        requestPayload,
      );

      if (response.status === 201) {
        return response;
      } else if (response.status === 400) {
        return response.data;
      } else if (response.status === 401) {
        // window.location.href = '/logout';
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }

      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      const errorMessage =
        axiosError.response && typeof axiosError.response.data === "string"
          ? axiosError.response.data
          : "Unknown error";
      if (axiosError && axiosError.status === 401) {
        requestPayload.navigateToLogout("/logout");
        return {
          status: false,
          message: "UnAuthrized",
        };
      } else {
        return {
          status: false,
          message: errorMessage,
        };
      }
    }
  },
  delRoles: async (
    delPayload: any,
  ): Promise<string | IServerError | IResponse | any> => {
    // return new Promise(resolve => setTimeout(() => resolve("Flex Field has been deleted successfully"), 1000));
    try {
      const response: AxiosResponse<string> = await http.delete<string>(
        `/v1/roles/${delPayload.rolesId}/`,
      );

      if (response.status === 204) {
        return "Roles has been deleted successfully";
      } else if (response.status === 200) {
        return "Roles has been deleted successfully";
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }

      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      const errorMessage =
        axiosError.response && typeof axiosError.response.data === "string"
          ? axiosError.response.data
          : "Unknown error";
      if (axiosError && axiosError.status === 401) {
        delPayload.navigateToLogout("/logout");
        return {
          status: false,
          message: "UnAuthrized",
        };
      } else {
        return {
          status: false,
          message: errorMessage,
        };
      }
    }
  },
  delBulkRoleses: async (
    requestPayload: any,
  ): Promise<string | IServerError | IResponse> => {
    try {
      const response = await http.delete<string>(`/v1/roles/`, {
        data: requestPayload.rolesIds,
      });
      if (response.status === 200) {
        return response.data;
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }

      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      const errorMessage =
        axiosError.response && typeof axiosError.response.data === "string"
          ? axiosError.response.data
          : "Unknown error";
      if (axiosError && axiosError.status === 401) {
        requestPayload.navigateToLogout("/logout");
        return {
          status: false,
          message: "UnAuthrized",
        };
      } else {
        return {
          status: false,
          message: errorMessage,
        };
      }
    }
  },
  getGetRolesDDL: async (
    clientId: string,
  ): Promise<any | IServerError | IResponse | null> => {
    const response: AxiosResponse<any[]> = await http.get<any[]>(
      `/v1/roles/role-ddl?client_id=${clientId}`,
    );

    if (response.status === 200) {
      return response.data;
    }

    return {
      status: false,
      message: "Something went wrong please try again later.",
    };
  },
  archiveRoles: async (
    archivePayload: any,
  ): Promise<string | IServerError | IResponse | any> => {
    // return new Promise(resolve => setTimeout(() => resolve("Flex Field has been deleted successfully"), 1000));
    try {
      const response: AxiosResponse<string> = await http.post<string>(
        `/v1/roles/${archivePayload.rolesId}/`,
      );

      if (response.status === 201) {
        return "Roles has been archived successfully";
      } else if (response.status === 200) {
        return "Roles has been archived successfully";
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }

      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      const errorMessage =
        axiosError.response && typeof axiosError.response.data === "string"
          ? axiosError.response.data
          : "Unknown error";
      if (axiosError && axiosError.status === 401) {
        archivePayload.navigateToLogout("/logout");
        return {
          status: false,
          message: "UnAuthrized",
        };
      } else {
        return {
          status: false,
          message: errorMessage,
        };
      }
    }
  },
  getRolesDDL: async (): Promise<any | IServerError | IResponse | null> => {
    try {
      const response: AxiosResponse<IDropDownListResponse[]> =
        await http.get<IDropDownListResponse[]>(`/v1/roles/roles-ddl`);
      if (response.status === 200) {
        return response.data;
      }

      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch {}
  },
};
